import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { ThemeProvider } from './hooks/useTheme';
import LoginPage from './pages/LoginPage';
import CollectionPage from './pages/CollectionPage';
import SharedCollectionPage from './pages/SharedCollectionPage';
import './styles/globals.css';

const Logo = () => (
  <svg width="48" height="48" viewBox="0 0 512 512" fill="none" style={{display:'block'}}>
    <rect width="512" height="512" rx="100" fill="#FDFAF6"/>
    <rect width="512" height="512" rx="100" fill="none" stroke="#EAE4DC" strokeWidth="6"/>
    <rect x="64"  y="330" width="384" height="58" rx="10" fill="#F04E1A"/>
    <rect x="64"  y="330" width="12"  height="58" rx="4"  fill="#C83E12"/>
    <rect x="80"  y="264" width="352" height="58" rx="10" fill="#F5C842"/>
    <rect x="80"  y="264" width="12"  height="58" rx="4"  fill="#D4A800"/>
    <rect x="64"  y="198" width="384" height="58" rx="10" fill="#3B6FBF"/>
    <rect x="64"  y="198" width="12"  height="58" rx="4"  fill="#2A509A"/>
    <rect x="96"  y="132" width="280" height="58" rx="10" fill="#5A9E7A"/>
    <rect x="96"  y="132" width="12"  height="58" rx="4"  fill="#3D7A5A"/>
    <ellipse cx="370" cy="104" rx="90" ry="60" fill="#FFFFFF" stroke="#F04E1A" strokeWidth="8"/>
    <path d="M322 152 L296 188 L338 164 Z" fill="#FFFFFF" stroke="#F04E1A" strokeWidth="8" strokeLinejoin="round" paintOrder="stroke"/>
    <circle cx="340" cy="104" r="10" fill="#F04E1A"/>
    <circle cx="370" cy="104" r="10" fill="#F04E1A"/>
    <circle cx="400" cy="104" r="10" fill="#F04E1A"/>
  </svg>
);

function Loading() {
  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:'1rem', background:'var(--bg)' }}>
      <Logo/>
      <div style={{ fontFamily:"'Bangers',cursive", fontSize:'2rem', letterSpacing:'.06em', color:'var(--orange)' }}>Bulléthèque</div>
    </div>
  );
}

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading/>;
  return user ? children : <Navigate to="/login" replace/>;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return !user ? children : <Navigate to="/" replace/>;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicRoute><LoginPage/></PublicRoute>}/>
            <Route path="/partage/:shareId" element={<SharedCollectionPage/>}/>
            <Route path="/*" element={<PrivateRoute><CollectionPage/></PrivateRoute>}/>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
